import { useEffect } from 'react';

import { Grid } from '@mui/material';

import { CuredApiPaths } from 'models/enums';
import Card from 'pages/InsightsPage/dashboards/Card';
import { FiltersForApiState } from 'pages/InsightsPage/dashboards/filtering/types';
import useFilteredData from 'pages/InsightsPage/dashboards/filtering/useFilteredData';

type DataProps = {
    calls_attempted: string;
    call_answered_rate: string;
    average_call_duration: string;
    send_count: string;
    opt_out_rate: string;
    sent_to_voicemail: string;
};

type Props = {
    filtersForApi: FiltersForApiState;
};

const VoiceStatsCards = ({ filtersForApi }: Props) => {
    const { getData, isError, isLoading, data } = useFilteredData({
        key: 'voice-dashboard/stats',
        path: CuredApiPaths.REPORT_VOICE_STATS,
    });

    useEffect(() => {
        getData(filtersForApi);
    }, [filtersForApi, getData]);

    const getFigure = (figure: string, isPercentage?: boolean) =>
        isPercentage ? `${figure}%` : Number(figure).toLocaleString();

    const statsData = data as DataProps;

    return (
        <Grid container item spacing={2} xs={12} md={6}>
            <Grid item xs={12} sm={6} md={4}>
                <Card
                    isError={isError}
                    isFigureCard
                    isLoading={isLoading}
                    label="Calls Attempted"
                    infoLabel="Total calls made"
                >
                    {getFigure(statsData?.calls_attempted)}
                </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Card
                    isError={isError}
                    isFigureCard
                    isLoading={isLoading}
                    label="Call Answered Rate"
                    infoLabel="Percentage answered"
                >
                    {getFigure(statsData?.call_answered_rate, true)}
                </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Card
                    isError={isError}
                    isFigureCard
                    isLoading={isLoading}
                    label="Average Call Duration"
                    infoLabel="Mean duration"
                >
                    {getFigure(statsData?.average_call_duration)}
                </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Card isError={isError} isFigureCard isLoading={isLoading} label="Send Count" infoLabel="Messages sent">
                    {getFigure(statsData?.send_count)}
                </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Card
                    isError={isError}
                    isFigureCard
                    isLoading={isLoading}
                    label="Opt Out Rate"
                    infoLabel="Unsubscribe rate"
                >
                    {getFigure(statsData?.opt_out_rate, true)}
                </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Card
                    isError={isError}
                    isFigureCard
                    isLoading={isLoading}
                    label="Sent to Voicemail"
                    infoLabel="Voicemail messages"
                >
                    {getFigure(statsData?.sent_to_voicemail)}
                </Card>
            </Grid>
        </Grid>
    );
};

export default VoiceStatsCards;
